export enum TreatmentKeys {
  CMT_SPINAL_1_TO_2_REGIONS = 'cmtSpinal1-2Regions',
  CMT_SPINAL_3_TO_4_REGIONS = 'cmtSpinal3-4Regions',
  CMT_SPINAL_5_REGIONS = 'cmtSpinal5Regions',

  CMT_EXTRASPINAL_1_PLUS = 'cmtExtraspinal1+',

  MASSAGE_THERAPY = 'massageTherapy',
  MANUAL_THERAPY = 'manualTherapy',

  ACUPUNCTURE = 'acupuncture',
  ACUPUNCTURE_WITH_E_STIM = 'acupunctureWithEStim',
  DRY_NEEDLING_1_TO_2_MUSCLES = 'dryNeedling1-2Muscles',
  DRY_NEEDLING_3_PLUS_MUSCLES = 'dryNeedling3+Muscles',
}

/**
 * Treatment display names mapping
 */
export const TreatmentDisplayNames: Record<TreatmentKeys, string> = {
  [TreatmentKeys.CMT_SPINAL_1_TO_2_REGIONS]: 'CMT, Spinal 1-2 Regions',
  [TreatmentKeys.CMT_SPINAL_3_TO_4_REGIONS]: 'CMT, Spinal 3-4 Regions',
  [TreatmentKeys.CMT_SPINAL_5_REGIONS]: 'CMT, Spinal 5 Regions',
  [TreatmentKeys.CMT_EXTRASPINAL_1_PLUS]: 'CMT, Extraspinal 1+',
  [TreatmentKeys.MASSAGE_THERAPY]: 'Massage Therapy',
  [TreatmentKeys.MANUAL_THERAPY]: 'Manual Therapy',
  [TreatmentKeys.ACUPUNCTURE]: 'Acupuncture',
  [TreatmentKeys.ACUPUNCTURE_WITH_E_STIM]: 'Acupuncture with E-Stim',
  [TreatmentKeys.DRY_NEEDLING_1_TO_2_MUSCLES]: 'Dry Needling, 1-2 Muscles',
  [TreatmentKeys.DRY_NEEDLING_3_PLUS_MUSCLES]: 'Dry Needling, 3+ Muscles',
};

/**
 * Helper function to get treatment display name
 */
const getTreatmentDisplayName = (key: TreatmentKeys): string => {
  return TreatmentDisplayNames[key] || key;
};

/**
 * Array of all treatment keys for iteration
 */
const TREATMENT_KEYS_ARRAY = Object.values(TreatmentKeys);

/**
 * CMT-specific treatment keys
 */
const CMT_TREATMENT_KEYS = [
  TreatmentKeys.CMT_SPINAL_1_TO_2_REGIONS,
  TreatmentKeys.CMT_SPINAL_3_TO_4_REGIONS,
  TreatmentKeys.CMT_SPINAL_5_REGIONS,
  TreatmentKeys.CMT_EXTRASPINAL_1_PLUS,
] as const;

/**
 * Dry Needling treatment keys
 */
const DRY_NEEDLING_TREATMENT_KEYS = [
  TreatmentKeys.DRY_NEEDLING_1_TO_2_MUSCLES,
  TreatmentKeys.DRY_NEEDLING_3_PLUS_MUSCLES,
] as const;

export enum treatmentSubCategories {
  CMT = 'cmt',
  CMT_EXTRASPINAL = 'cmtExtraspinal',
  MASSAGE_THERAPY = 'massageTherapy',
  MANUAL_THERAPY = 'manualTherapy',
  ACUPUNCTURE = 'acupuncture',
  ACUPUNCTURE_WITH_E_STIM = 'acupunctureWithEStim',
  DRY_NEEDLING = 'dryNeedling',
}
